export default __webpack_public_path__ + "static/media/Suspicious Contract.ac649919.png";